import React, { useEffect, useState } from "react";
import CardItemListing from "../components/cards/CardItemListing";
import { useAtom } from "jotai";
import { recipientIdAtom, showIndividualMessageBoxAtom, userAtom } from "../store";
import { getListingsByUserId, updateCardState } from "../firebase/listings";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { getUserData, getUserRating, getUserReviews } from "../firebase/users";
import DialogConfirmation from "../components/dialogs/DialogConfirmation";
import { formatDate } from "../utils";
import Pagination from "../components/commons/Pagination";
import CardReview from "../components/cards/CardReview";
import Breadcrumb from "../components/Breadcrumb";

const PublicProfile = () => {
    const [userData, setUserData] = useState(null)
    const [updatedTime, setUpdatedTime] = useState(0)
    const [loading, setLoading] = useState(true)
    const { userId } = useParams()
    const [items, setItems] = useState([])
    const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
    const [recipientId, setRecipientId] = useAtom(recipientIdAtom)
    const fields = ["Title", "Date Published", "Listing Price", "Available Amount", "Other"]
    const itemsPerPage = 4
    const [currentPage, setCurrentPage] = useState(1)
    const [currentMobilePage, setCurrentMobilePage] = useState(1)
    const [reviews, setReviews] = useState([])
    const [ratings, setRatings] = useState(0)
    const [showCounts, setShowCounts] = useState(3)
    const [countsByRating, setCountsByRating] = useState(null)


    useEffect(() => {
        getUserData(userId).then((data) => {
            setUserData(data)
            setLoading(false)
        })
        getListingsByUserId(userId).then(data => {
            setItems(data)
        })
        getUserReviews(userId).then((data) => {
            setReviews(data.reviews)
            setCountsByRating(data.countsByRating)
        })

        getUserRating(userId).then((data) => {
            setRatings(data)
        })
    }, [])

    const setMessageToSeller = () => {
        setShowIndividualMessageBox(true)
        setRecipientId(userData.id)
    }

    return (
        <div className="flex w-full h-[100vh]">
            <div className="p-14 max-w-[1440px] w-full m-auto">
                <DialogConfirmation
                    open={loading}
                    onClose={() => { }}
                    type="loading"
                    title="Please wait"
                    message="We are processing your booking request. Please wait and don’t close this page"
                    buttonText="Cancel"
                    onButtonClick={
                        () => { }
                    }
                />

                <Breadcrumb link="/listing" />

                {!loading &&
                    <div>
                        <hr className="border-gray mb-5" />

                        <div className="flex justify-between mb-[80px]">
                            <div className="flex items-center space-x-2 lg:space-x-4">
                                <div className="w-12 h-12 flex justify-center items-center">
                                    <img src="/assets/avatars/default.png" className="w-full h-full" alt="seller" />
                                </div>

                                <div className="flex flex-col items-start">
                                    <span className="text-sm lg:text-base text-white">
                                        {userData.displayName}
                                    </span>
                                </div>
                            </div>

                            <div
                                className="flex flex-wrap border-[1px] border-primary text-sm px-8 py-3 text-primary transition-all opacity-50 border-style-decoration"
                            >
                                <img src="/assets/icons/icon-message-primary.svg" alt='message' className="mr-1" />

                                Send Message
                            </div>
                        </div>


                        <div className="page-title text-white !mb-8">
                            Listings
                        </div>

                        <hr className="border-gray mb-8" />
                        {
                            items.length > 0 ?
                                <>
                                    <div className="max-lg:hidden">
                                        <div className="w-full overflow-auto">
                                            <table className="w-full">
                                                <thead>
                                                    <tr className="bg-[#2E2E2E] border-[1px] border-gray py-3 text-sm text-[#717171]">
                                                        {
                                                            fields.map((item, index) =>
                                                                <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}`}>
                                                                    {item}
                                                                </th>
                                                            )
                                                        }
                                                    </tr>
                                                </thead>

                                                <div className="pt-1" />
                                                <tbody className="text-white space-y-1 text-sm">
                                                    {
                                                        items.slice(itemsPerPage * (currentPage - 1), itemsPerPage * currentPage).map((item, index) =>
                                                            <tr key={`offer-item-sent-${currentPage}-${item.title}-${index}`} className="border-[1px] border-gray text-nowrap">
                                                                <td className="py-2 pl-3 pr-20 lg:min-w-[400px] min-w-[200px]">
                                                                    <div className="flex items-center">
                                                                        <img
                                                                            src={item.pictures[0]}
                                                                            alt="picture"
                                                                            className="w-[50px] h-[50px] mr-6 border-[1px] border-gray"
                                                                        />

                                                                        <span className="uppercase text-sm">
                                                                            {item.title}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="lg:min-w-[200px] pr-10">
                                                                    {formatDate(item.created_at.seconds)}
                                                                </td>

                                                                <td className="lg:min-w-[200px] pr-10">
                                                                    $ {item.price.toFixed(2)}
                                                                </td>

                                                                <td className="lg:min-w-[200px] pr-10">
                                                                    {item.quantity}
                                                                </td>

                                                                <td className="pr-3">
                                                                    <div className="flex items-center">
                                                                        {
                                                                            item.state === 'approved' ?
                                                                                <div
                                                                                    className="flex items-center justify-center mr-8 text-white border-white border-[1px] opacity-60 w-[170px] h-[45px]"
                                                                                >
                                                                                    View Listing
                                                                                </div> :
                                                                                item.state === 'pending' ?
                                                                                    <div
                                                                                        className="flex items-center justify-center mr-8 text-white border-white border-[1px] bg-[#2A2A2A] w-[170px] h-[45px] opacity-60"
                                                                                    >
                                                                                        Pending Approval
                                                                                    </div> :
                                                                                    <div
                                                                                        className="flex items-center justify-center mr-8 text-[#5D5D5D] border-[#575757] border-[1px] bg-[#2A2A2A] w-[170px] h-[45px] opacity-60"
                                                                                    >
                                                                                        Listing Declined
                                                                                    </div>
                                                                        }
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div >

                                        <div className="mt-9">
                                            <Pagination itemsPerPage={itemsPerPage} totalItems={items.length} onPageChange={(value) => setCurrentPage(value)} />
                                        </div>
                                    </div>



                                    <div className="lg:hidden">
                                        <div className="grid sm:grid-cols-2 grid-cols-1 gap-5">
                                            {
                                                items.slice(3 * (currentMobilePage - 1), 3 * currentMobilePage).map(item =>
                                                    <div className="p-[10px] border-[1px] border-gray bg-[#191919]" key={item.id}>
                                                        <div className="flex w-full">
                                                            <img src={item.pictures[0]} className="w-[113px] h-[113px] object-cover border-[1px] border-gray mr-4" alt="image" />

                                                            <div className="w-full mb-9">
                                                                <div className="uppercase text-white text-sm">{item.title}</div>

                                                                <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                                                                    <span>Listing Price</span>
                                                                    <span className="text-white">$ {item.price.toFixed(2)}</span>
                                                                </div>

                                                                <div className="mt-4 w-full flex justify-between text-[#717171] text-xs">
                                                                    <span>Available Amount</span>
                                                                    <span className="text-white">5</span>
                                                                </div>

                                                                <div className="mt-3 w-full flex justify-between text-[#717171] text-xs">
                                                                    <span>Published</span>
                                                                    <span className="text-white">{formatDate(item.created_at.seconds)}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="w-full items-center">
                                                            <Link to={`/marketplace/${item.id}`}
                                                                className="flex items-center justify-center w-full mb-2 text-sm text-white border-gray border-[1px] h-[40px]">
                                                                <img src="/assets/icons/icon-edit.svg" alt="edit" className="w-4 h-4 mr-1" />
                                                                Edit Listing
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className="mt-9">
                                            <Pagination itemsPerPage={3} totalItems={items.length} onPageChange={(value) => setCurrentMobilePage(value)} />
                                        </div>
                                    </div>
                                </>
                                :
                                <div className="text-white text-lg text-center mt-8">
                                    No listings you have uploaded
                                </div>
                        }


                        {
                            reviews.length > 0 ?
                                <>
                                    <div className="page-title text-white !mb-8 mt-[80px]">
                                        Reviews
                                    </div>

                                    <hr className="border-gray mb-8" />

                                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-20 mt-12">
                                        <div className="lg:hidden max-w-[270px]">
                                            <h4 className="font-aero text-[32px] lg:text-[48px] uppercase text-white">
                                                {ratings.toFixed(1)}
                                            </h4>
                                            <div className="flex items-center">
                                                <img
                                                    src="/assets/icons/icon-star-fill.svg"
                                                    className="w-[14px] lg:w-[28px]"
                                                />
                                                <img
                                                    src="/assets/icons/icon-star-fill.svg"
                                                    className="w-[14px] lg:w-[28px]"
                                                />
                                                <img
                                                    src="/assets/icons/icon-star-fill.svg"
                                                    className="w-[14px] lg:w-[28px]"
                                                />
                                                <img
                                                    src="/assets/icons/icon-star-fill.svg"
                                                    className="w-[14px] lg:w-[28px]"
                                                />
                                                <img
                                                    src="/assets/icons/icon-star-fill.svg"
                                                    className="w-[14px] lg:w-[28px]"
                                                />
                                            </div>
                                            <span className="block text-lg text-white whitespace-nowrap mt-1">
                                                Based on {reviews.length} Reviews
                                            </span>
                                        </div>

                                        <div className="md:w-[400px] w-full max-w-full flex items-center gap-6">
                                            <div className="w-full max-w-full space-y-2 md:space-y-4">
                                                {
                                                    [4, 3, 2, 1, 0].map((item) =>
                                                        <div className="flex relative justify-between items-center gap-3" key={`rating-${item}`}>
                                                            <div className="flex items-center">
                                                                <span className="text-white text-xs md:text-xl inline-block mr-5 md:mr-7">
                                                                    {item + 1}
                                                                </span>
                                                                <img
                                                                    src="/assets/icons/icon-star-fill-white.svg"
                                                                    className="max-w-[14px] md:max-w-[unset] absolute left-5 md:left-5"
                                                                />
                                                            </div>
                                                            <div className="relative w-full h-[8px] md:max-w-[340px] bg-white left-0">
                                                                <div className="absolute top-0 left-0 h-full bg-primary" style={{ width: (countsByRating[item] * 100) / reviews.length + '%' }}></div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div className="hidden lg:block max-w-[270px]">
                                            <h4 className="font-aero text-[32px] lg:text-[48px] uppercase text-white">
                                                {ratings.toFixed(1)}
                                            </h4>
                                            <div className="flex items-center">
                                                {
                                                    [1, 2, 3, 4, 5].map(item =>
                                                        <img
                                                            src="/assets/icons/icon-star-fill.svg"
                                                            className="w-[14px] lg:w-[28px]"
                                                            key={`star-${item}`}
                                                        />
                                                    )
                                                }
                                            </div>
                                            <span className="block text-lg text-white whitespace-nowrap mt-1">
                                                Based on {reviews.length} Reviews
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mt-20">
                                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                                            {reviews.slice(0, showCounts).map((review) => (
                                                <CardReview
                                                    key={review.id}
                                                    rating={review.rating}
                                                    timeAgo={review.created_at}
                                                    title={review.title}
                                                    description={review.description}
                                                    username={review.reviewer_name}
                                                />
                                            ))}
                                        </div>

                                        {
                                            reviews.length > showCounts ?
                                                <div className="w-full lg:w-fit mx-auto mt-8 lg:mt-16">
                                                    <button className="text-white text-sm underline" onClick={() => setShowCounts(showCounts + 3)}>
                                                        View More
                                                    </button>
                                                </div>
                                                : ""
                                        }
                                    </div>
                                </> :
                                <>
                                </>
                            // <div className="text-white text-lg">
                            //     No Reviews
                            // </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default PublicProfile;
